/* eslint-disable no-console */
import { useCallback } from 'react';
import { useBuildVars } from '../config/build-config';
import { disableSameOriginRequests } from './query-consts';
import { useSiteConfig } from '../config/site-config/useSiteConfig';

const win = window as any;

win.toggleSameOriginApis = () => {
  const isDisabled = localStorage.getItem(disableSameOriginRequests);
  const newVal = isDisabled === 'true' ? 'false' : 'true';
  localStorage.setItem(disableSameOriginRequests, newVal);
  console.log(
    `[cross origin requests] ${
      newVal === 'true' ? 'enabled' : 'disabled'
    } - refresh page to see changes`
  );
};

export const getSameOriginApiBasePath = () => {
  return `/api`;
};

export const sameOriginEnabledCountries: { [siteCode: string]: boolean } = {
  de: false,
  in: false,
  us: true,
};

// Controls whether to use same origin APIs or not. NOTE: Config API call is
//  out of scope of QueryClient and handled separately in SiteConfigProvider.tsx.
export const useSameOriginApis = () => {
  const buildVars = useBuildVars();
  const { siteCode } = useSiteConfig();

  const shouldUseSameOriginApis = useCallback(() => {
    if (buildVars.buildEnvironment === 'development') return false;
    if (localStorage.getItem(disableSameOriginRequests) === 'true')
      return false;
    if (sameOriginEnabledCountries[siteCode]) return true;
    return (
      buildVars.buildEnvironment !== 'production' &&
      buildVars.buildEnvironment !== 'productionbeta' &&
      localStorage.getItem(disableSameOriginRequests) !== 'true'
    );
  }, [buildVars.buildEnvironment, siteCode]);

  return shouldUseSameOriginApis;
};
